export default {
  platform: {
    title: "Paramètres plateforme",
    name: "Titre",
    namePh: "Saisir le titre",
    platformId: "ID plateforme",
    logo: "Logo",
    contact: "Contact",
    contactPh: "Saisir le contact",
    txKey: "Clé Tencent Map",
    txKeyPh: "Saisir la clé Tencent Map",
    intro: "Présentation",
    introPh: "Saisir la présentation",
    regAgreement: "Conditions d'inscription",
    management: "Règlement",
    aboutUs: "À propos de nous",
  },
  agreement: {
    title: "Accords",
    platformRule: "Règles plateforme",
    riderRule: "Règles livreurs",
    add: "Ajouter un accord",
    ruleTitle: "Titre",
    ruleDetail: "Contenu",
    ruleSort: "Tri",
    ruleSortPh: "Saisir le tri",
    ruleTitlePh: "Saisir le titre",
  },
  ad: {
    title: "Publicités",
    add: "Ajouter",
    edit: "Modifier",
    sort: "Tri",
    sortPh: "Saisir le tri",
    name: "Titre",
    namePh: "Saisir le titre",
    image: "Image",
    displayStatus: "Affichage",
    enableStatus: "Statut",
    show: "Afficher",
    hide: "Masquer",
    enable: "Activer",
    disable: "Désactiver",
  },
  notice: {
    title: "Annonces",
    add: "Ajouter",
    noticeTitle: "Titre",
  },
  message: {
    title: "Notifications",
    add: "Nouvelle notification",
  },
  sms: {
    title: "Paramètres SMS",
    aliyunSms: "SMS Alibaba Cloud",
    accessKeyIdPh: "Saisir access_key_id",
    accessKeySecretPh: "Saisir access_key_secret",
    templateSign: "Signature du modèle",
    templateSignPh: "Saisir la signature du modèle",
    testPhone: "Téléphone de test",
    testPhonePh: "Saisir le numéro de test",
    verifyCodeTemplateTitle: "Modèles SMS de code de vérification",
    accountRegister: "Inscription",
    changePassword: "Modifier le mot de passe",
    templateIdPh: "Saisir l'ID du modèle",
    sendTest: "Envoyer un test",
  },
  payment: {
    title: "Paramètres WeChat Pay",
    normalMchId: "N° marchand paiement standard",
    normalMchIdPh: "Saisir le n° marchand",
    normalMchKey: "Clé marchand paiement standard",
    normalMchKeyPh: "Saisir la clé marchand",
    certPem: "Certificat apiclient_cert.pem",
    keyPem: "Certificat apiclient_key.pem",
    certPh: "Saisir le certificat prestataire",
    uploaded: "Téléversé",
    certTip: "Ouvrir apiclient_cert.pem avec un éditeur de texte et coller tout le contenu ici",
    keyTip: "Ouvrir apiclient_key.pem avec un éditeur de texte et coller tout le contenu ici",
  },
  storage: {
    title: "Stockage distant",
    localStorage: "Stockage local",
    qiniu: "Qiniu Cloud",
    aliyun: "Alibaba Cloud OSS",
    tencent: "Tencent Cloud COS",
    qiniuNotice: "Après activation de Qiniu, téléversez le contenu de /attachment (sans le dossier lui-même) vers Qiniu Cloud.",
    aliyunNotice: "Après activation d'Alibaba OSS, téléversez le contenu de /attachment (sans le dossier lui-même) vers Alibaba OSS.",
    tencentNotice: "Après activation de Tencent COS, téléversez le contenu de /attachment (sans le dossier lui-même) vers Tencent Cloud.",
    accesskey: "Accesskey",
    accesskeyPh: "Saisir Accesskey",
    accesskeyRemark: "Clé publique pour la signature",
    secretkey: "Secretkey",
    secretkeyPh: "Saisir Secretkey",
    secretkeyRemark: "Clé privée pour la signature",
    bucket: "Bucket",
    bucketPh: "Saisir Bucket",
    bucketRemark: "Le bucket doit être en lecture publique",
    bucketRegion: "Région du bucket",
    selectRegion: "Sélectionner la région",
    url: "Url",
    urlPh: "Saisir Url",
    qiniuUrlRemark: "Qiniu permet un domaine personnalisé. Préfixez http:// ou https://, sans '/' final. Ex. : http://abc.co",
    accessKeyId: "Access Key ID",
    accessKeyIdPh: "Saisir Access Key ID",
    accessKeyIdRemark: "Access Key ID est la clé d'accès à l'API Alibaba Cloud. Conservez-la en sécurité.",
    accessKeySecret: "Access Key Secret",
    accessKeySecretPh: "Saisir Access Key Secret",
    accessKeySecretRemark: "Access Key Secret est la clé secrète Alibaba Cloud. Renseignez Access Key ID et Secret avant de choisir un bucket.",
    endpointSelect: "Endpoint",
    endpointSelectPh: "Sélectionner Endpoint",
    endpointRemark: "Après renseignement des clés, sélectionnez un bucket existant (lecture publique) ou saisissez-le manuellement.",
    bucketSelect: "Bucket",
    bucketSelectPh: "Sélectionner bucket",
    customUrl: "URL personnalisée",
    customUrlPh: "Saisir l'URL personnalisée",
    aliyunUrlRemark: "Alibaba OSS permet une URL personnalisée ; sinon l'URL système est utilisée. Préfixez http:// ou https://, sans '/' final.",
    appId: "APPID",
    appIdPh: "Saisir APPID",
    appIdRemark: "APPID est l'identifiant unique du projet",
    secretId: "SecretID",
    secretIdPh: "Saisir SecretID",
    secretIdRemark: "SecretID est la clé secrète du projet. Conservez-la en sécurité.",
    secretKey: "SecretKEY",
    secretKeyPh: "Saisir SecretKEY",
    secretKeyRemark: "SecretKEY est la clé secrète du projet. Conservez-la en sécurité.",
    tencentBucketPh: "Saisir Bucket",
    tencentRegionRemark: "Sélectionnez la région du bucket, ou « aucune » si absent",
    tencentUrlRemark: "Tencent Cloud permet un domaine personnalisé. Préfixez http:// ou https://, sans '/' final.",
    regionEastChina: "Est de la Chine",
    regionNorthChina: "Nord de la Chine",
    regionSouthChina: "Sud de la Chine",
    regionNorthAmerica: "Amérique du Nord",
    regionHangzhou: "Est 1 (Hangzhou)",
    regionShanghai: "Est 2 (Shanghai)",
    regionQingdao: "Nord 1 (Qingdao)",
    regionBeijing: "Nord 2 (Pékin)",
    regionZhangjiakou: "Nord 3 (Zhangjiakou)",
    regionHohhot: "Nord 5 (Hohhot)",
    regionShenzhen: "Sud 1 (Shenzhen)",
    regionHongKong: "Hong Kong",
    regionChengdu: "Sud-Ouest 1 (Chengdu)",
    regionBeijingShort: "Pékin",
    regionNanjing: "Nanjing",
    regionShanghaiShort: "Shanghai",
    regionGuangzhou: "Guangzhou",
    regionChengduShort: "Chengdu",
    regionChongqing: "Chongqing",
  },
  idRecognition: {
    title: "Reconnaissance carte d'identité",
    appIdPh: "Saisir APP ID",
    apiKeyPh: "Saisir API KEY",
    secretKeyPh: "Saisir SECRET KEY",
  },
  versionUpdate: {
    title: "Mise à jour",
    version: "Numéro de version",
    versionPh: "Saisir la dernière version, ex. 1.0.1",
    downloadUrl: "URL de téléchargement",
    downloadUrlPh: "Saisir l'URL de téléchargement de l'App",
    forceUpdate: "Mise à jour forcée",
    content: "Notes de version",
    contentPh: "Saisir les notes de mise à jour",
  },
};
